export function contactName({ prefix, firstName, lastName }: { prefix: string, firstName: string, lastName: string }): string {
  let contactName: string = '';
  if(prefix) {
    contactName = `${prefix}.`;
  }
  if(firstName) {
    contactName = `${contactName} ${firstName}`;  
  }
  if(lastName) {
    contactName = `${contactName} ${lastName}`;
  }
  return contactName;
}